import { useState } from 'react';

let lastId = 0;
const nextId = () => {
  lastId += 1;
  return `kv-${lastId}`;
};

const toEntries = (object) =>
  Object.entries(object || {}).map(([key, value]) => ({ id: nextId(), key, value }));

/**
 * An editable list of key/value pairs, from the legacy hook of the same name.
 * The ids only keep React's rows stable while a key is being typed; they never
 * leave the form.
 *
 * @param {Object.<string, string>} initialState
 */
export function useKeyValueStore(initialState) {
  const [store, setStore] = useState(() => toEntries(initialState));

  const addCustomValue = (key, value, handleSnack) => {
    if (!key) {
      handleSnack(true, "Debes ingresar una llave");
      return;
    }
    if (!value) {
      handleSnack(true, "Debes ingresar un valor");
      return;
    }
    setStore((prev) => [...prev, { id: nextId(), key, value }]);
  };

  const updateKey = (id, newKey) => {
    setStore((prev) =>
      prev.map((item) => (item.id === id ? { ...item, key: newKey } : item))
    );
  };

  const updateValue = (id, newValue) => {
    setStore((prev) =>
      prev.map((item) => (item.id === id ? { ...item, value: newValue } : item))
    );
  };

  const removeKey = (id) => {
    setStore((prev) => prev.filter((item) => item.id !== id));
  };

  const getObjectStore = () =>
    store.reduce((acc, curr) => ({ ...acc, [curr.key]: curr.value }), {});

  /** Replaces the pairs with those of a stored webhook. */
  const resetFrom = (object) => setStore(toEntries(object));

  return {
    store,
    addCustomValue,
    updateKey,
    updateValue,
    removeKey,
    getObjectStore,
    resetFrom,
  };
}
